












import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";
import OrderView from "./Order.vue";
import { Order } from "@/models/order";
import { Invoice } from "@/models/invoice";
import billingAPI from "@/services/billing";

const types: { [key: string]: any } = {
  "order": true,
  "invoice": true,
}

@Component({
  components: {
    loader,
    OrderView,
  },
})
export default class Overview extends Vue {
  @Prop({ default: "" }) public type?: string;
  @Prop({ default: "" }) public id?: number;

  loading: string | boolean = "Loading";
  item: Order | Invoice | null = null;

  mounted() {
    if (!this.type || !types[this.type]) {
      this.loading = "invalid type: ${this.type}";
      return;
    }
    if (!this.id) {
      this.loading = "invalid ${this.type} id: ${this.id}";
      return;
    }

    if (this.type === 'order') {
      this.loadOrder(this.id)
    }
  }

  private async loadOrder(orderID: number) {
    this.loading = "Loading order " + orderID;
    try {
      const o = await billingAPI.getOrder(orderID);
      this.item = o;
    } catch (e) {
      this.loading = `${e}`;
      return;
    }
    this.loading = false;
  }

}
